/**
 * @typedef {'logout_success' | 'password_changed' | 'token_expired'
 *   | 'token_invalid' | 'token_required'} SessionExitReason
 */

export const TOAST_PRESETS = {
  success: {
    autoClose: 5000,
    hideProgressBar: true,
    theme: 'light',
  },
  error: {
    autoClose: 5000,
    hideProgressBar: true,
    theme: 'colored',
  },
  warning: {
    autoClose: 6000,
    hideProgressBar: true,
    theme: 'light',
  },
  info: {
    autoClose: 5000,
    hideProgressBar: true,
    theme: 'light',
  },
  session: {
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: false,
    theme: 'colored',
  },
};

/** @type {Record<string, string>} */
export const SESSION_EXIT_MESSAGES = {
  logout_success: '登出成功，請重新登入',
  password_changed: '密碼已變更成功，五秒後回到登入頁',
  token_expired: '驗證過期，請重新登入',
  token_invalid: '驗證無效，請重新登入',
  token_required: '請先登入',
};
